import React from "react";
import { getSdk } from "../../services/sdkService";
import { HeadingStyled, ContainerStyled } from "../../styles/shared-styles";
import { SearchPageStyled, BlockStyled, LoadingStyled, GridStyled, ContainerKeyboardStyled } from "./styles/Styled";
import { goToDetailPageByProgramType } from "../../utils/goToDetailPage";
import {
  Input,
  Loading,
  Text,
  SimpleKeyboard,
  ArabicKeyboardSwap,
  SecondaryMenu
} from "../../services/visualLibraryService";
import { debounce, cancelDebounce } from "../../helpers/debounce";
import { config } from "../../config/config";
import { resolution } from "../../config/ui/resolutionConfig";
import { i18n, directions } from "../../services/i18nService";
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";
import { getSectionName, isADMNContent, isAVOD, isSVOD, isTVOD, tvodSearchTimeExpire } from "../../utils/tvodUtils";
import { showSignupPremiumPrompt } from "../../services/modalsService";
import { getNavigationReferences } from "../../services/navigationService";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { isUserAccountActive } from "../../services/accountStatusService";
import {
  sendSearchEventDataForBytePlus,
  sendCarouselClickEventDataForBytePlus,
  sendTrueViewImpressionForBytePlus
} from "../../services/byteEventService";
import { isHidePromptForKidsProfile } from "../../utils/promptUtils";
import { playHandler } from "../../utils/mediaDataRetrieval";
import { getPath } from "../../utils/getPath";

const PAGE = "search";
const ANALYTICS_CATEGORY = `${PAGE}|new`;
const NEWS = "news";
const MAGAZINE = "magazine";
const keyboardTypes = {
  WesternKeyboard: {
    name: "WesternKeyboard",
    languageCode: "en"
  },
  ArabicKeyboard: {
    name: "ArabicKeyboard",
    languageCode: "ar"
  }
};
const SECONDARY_ITEM_PREFIX = "secondaryItem_";
const SEARCH_NO_RESULTS = "search_noresults";
let minCharacters;
let SearchKeyboard = null;
let lastFocusedKey = null;
let allLanguages = null;
let isMounted = false;
let requestToken;
let isResultsFromKeyword = false;
let isDidYouMean = false;
let hasDidYouMean = false; // FIXME this and previous have almost the same name, what's the difference?
let isKeyboardInactive = true;
let isGridFocused = false;
let lastSearchResults = null;
let lastSearchTermTyped;
let setKeyboardFocusFromKeywords = false;
let lastKeywordFocused = null;
let searchId = 0;
//let signupInactivePromptTimer = null;

/**
 * Returns the index of the selected keyword
 */
function getSelectedKeywordIndex() {
  return (
    this.state.secondaryMenuSelectedIndex !== -1 && {
      secondaryMenuSelectedIndex: this.state.secondaryMenuSelectedIndex
    }
  );
}

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      titles: [],
      searchTermExists: false,
      searchTermLength: false,
      searching: false,
      secondaryMenuSelectedIndex:
        this.props.history.location.state &&
        this.props.history.location.state.secondaryMenuSelectedIndex !== undefined &&
        this.props.history.location.state.secondaryMenuSelectedIndex !== -1
          ? this.props.history.location.state.secondaryMenuSelectedIndex
          : -1,
      userData: {}
    };
    this.updateSearchQuery = this.updateSearchQuery.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    this.focusKeyboard = this.focusKeyboard.bind(this);
    this.onSwapKeyboard = this.onSwapKeyboard.bind(this);
    this.onRefKeyboard = this.onRefKeyboard.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSelectKeyword = this.onSelectKeyword.bind(this);
    this.onKeywordPress = this.onKeywordPress.bind(this);
    this.moveFocusLeft = this.moveFocusLeft.bind(this);
    this.moveFocusRight = this.moveFocusRight.bind(this);
    this.moveFocus = this.moveFocus.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getSearchResults = debounce(this._getSearchResults, getAppState().globalConfig?.search.delay);
    SearchKeyboard = Search.getKeyboardForLanguage(i18n.getLocale());
    allLanguages = Object.keys(config.get().locales);
    // The search minimum characters limit could be added by the languages [en, ar, fr]
    minCharacters =
      getAppState().globalConfig?.search.queryMinCharacters[i18n.getLocale()] ||
      getAppState().globalConfig?.search.queryMinCharacters.default;
    this.promptRef = React.createRef();
    this.signupInactivePromptTimer = null;
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.applicationState.currentFocus) {
      isGridFocused = nextProps.applicationState.currentFocus.indexOf("grid") > -1;
      isKeyboardInactive =
        nextProps.applicationState.currentFocus.indexOf(SECONDARY_ITEM_PREFIX) > -1 ||
        (isGridFocused && isResultsFromKeyword);
    }
    const { history } = nextProps;
    let defaultState = null;
    const appLangInLastSearch = history.location.state && history.location.state.appLangInLastSearch;
    if (appLangInLastSearch && appLangInLastSearch !== i18n.getLocale()) {
      lastFocusedKey = null;
      return {
        titles: [],
        keywords: [],
        didYouMean: [],
        searchTerm: "",
        searchTermExists: false
      };
    }
    if (!isMounted && history.location.state && history.location.state.lastSearch) {
      const { lastSearch, lastSearchTerm, lastKeywords } = history.location.state;
      return {
        titles: lastSearch,
        keywords: lastKeywords,
        didYouMean: [],
        searchTerm: lastSearchTerm,
        searchTermExists: !!lastSearchTerm.length,
        searchTermLength: !!(lastSearchTerm?.length < minCharacters)
      };
    }
    // Sometimes when selecting a keyword the result of the search contains didUMean data, which is incorrect.
    // hasDidYouMean is used in order to prevent this incorrect behavior from the new search API.
    if (
      isMounted &&
      setKeyboardFocusFromKeywords &&
      !isKeyboardInactive &&
      !hasDidYouMean &&
      !isGridFocused &&
      lastSearchResults &&
      lastSearchTermTyped.length >= minCharacters
    ) {
      isResultsFromKeyword = false;
      setKeyboardFocusFromKeywords = false;
      defaultState = {
        titles: lastSearchResults,
        searchTerm: lastSearchTermTyped,
        searchTermExists: !!lastSearchTermTyped.length,
        secondaryMenuSelectedIndex: -1
      };
      history.replace({
        state: {
          focusedItem: 0,
          scrollToRow: 0,
          secondaryMenuSelectedIndex: -1
        }
      });
    }
    return defaultState;
  }

  async componentDidMount() {
    const { onRef, stateActions, history } = this.props;
    sessionStorage.removeItem("refCarouselRecVariant"); // reset the value so that rec_variant value is correctly passed in search page.
    trackPage(PAGE);
    // when coming back from detai page, if search query is already there, call byte+ trueview
    this?.state?.titles &&
      this?.state?.titles.length > 0 &&
      sendTrueViewImpressionForBytePlus({
        currentScreen: sessionStorage?.getItem("currentScreen") || null,
        previousScreen: sessionStorage.getItem("prevScreen"),
        carouselContents: this?.state?.titles
      });
    onRef && onRef(this);
    stateActions.hideGlobalModal();
    // Checking whether the current keyboard swap side should be the default one when coming back from detail.
    if (
      history.location.state &&
      history.location.state.keyboardLangSwap &&
      this.keyboard.getCurrentName &&
      this.keyboard.getCurrentName() !== history.location.state.keyboardLangSwap
    ) {
      // Defer isMounted = true to swap keyboard callback.
      this.keyboard.switchKeyboard();
    } else {
      isMounted = true;
    }
    // The next lines check if the previous search was done in a different language than the current language the app
    // shows. In that case, the previous search will be reset (this happens in getDerivedStateFromProps) and that will
    // cause the grid not to have titles but the focus to be in the grid. This would cause a lost focus scenario so to
    // avoid that, we actively send the focus to the keyboard
    const appLangInLastSearch = history.location.state && history.location.state.appLangInLastSearch;
    if (appLangInLastSearch && appLangInLastSearch !== i18n.getLocale()) {
      this.focusKeyboard();
    }
    const userAccountStatus = await this.getUserAccountStatus();
    const userAddonStatus = await this.getUserAddonStatus();
    const isHidePromptForkids = await isHidePromptForKidsProfile();
    if (
      getAppState()?.signupPromptActive &&
      !isUserAccountActive(userAccountStatus) &&
      !userAddonStatus &&
      !isHidePromptForkids
    ) {
      this.startSignupInactivePromptTimer();
    }
    // get and store userdata to prevent requerying everytime for Byte+ event sending
    const sdk = await getSdk();
    let dt = await sdk.userManager.get();
    this.setState({ userData: dt });
  }

  getUserAccountStatus = async () => {
    return getAppState()?.userAccountStatus;
  };

  getUserAddonStatus = async () => {
    return getAppState()?.userAddonStatus;
  };

  startSignupInactivePromptTimer = () => {
    if (this.signupInactivePromptTimer !== null) clearTimeout(this.signupInactivePromptTimer);
    this.signupInactivePromptTimer = setTimeout(() => {
      showSignupPremiumPrompt.call(this, getNavigationReferences.call(this), this.closeModal);
    }, getAppState().signupPromptTimer || 5000);
  };

  componentWillUnmount() {
    isMounted = false;
    if (this.signupInactivePromptTimer) {
      clearTimeout(this.signupInactivePromptTimer);
    }
  }

  /**
   * Retrieves the search term, update the state and call to the method which will send the request
   * @param {String} input Search term
   */
  async updateSearchQuery(input) {
    const searchTerm = input.trim();
    const newState = { searchTerm: input, didYouMean: [] };
    requestToken = null;
    if (input === "" || searchTerm.length < minCharacters) {
      newState.titles = [];
      newState.keywords = [];
      newState.searchTermExists = false;
      newState.searching = false;
      newState.searchTermLength = !!(searchTerm && searchTerm.length < minCharacters);
    }
    cancelDebounce(searchId);
    this.setState(newState);
    if (searchTerm.length >= minCharacters) {
      this.setState({ searching: true, searchTermLength: false });
      searchId = await this.getSearchResults(searchTerm);
    } else {
      lastSearchTermTyped = searchTerm;
    }
  }

  /**
   * Send request to search and sets the results to state
   * @param {String} input Search term
   */
  async _getSearchResults(input) {
    cancelDebounce(searchId);
    if (!!input) {
      const { stateActions, history, setFocus } = this.props;
      const sdk = await getSdk();
      const searchConfig = {};
      let searchResult;
      !isResultsFromKeyword && !isDidYouMean && trackEvent(ANALYTICS_CATEGORY, "run", this.state.searchTerm);
      if (isAccessLimitedByParentalLevel()) {
        searchConfig.byCategory = "Kids"; // FIXME literal string
      }
      if (i18n.getLocale() === "ar") {
        // FIXME literal string
        searchConfig.lang = allLanguages.join(",");
      }
      try {
        const localCheck = (requestToken = {});
        searchResult = await sdk.mediaManager.search(input, searchConfig);
        hasDidYouMean = searchResult.didUMean && searchResult.didUMean.length > 0;
        if (localCheck !== requestToken || !this.state.searching) {
          // Response is ignored since belongs to a previous request.
          return;
        }
        // track byte+ event
        sendTrueViewImpressionForBytePlus({
          currentScreen: sessionStorage?.getItem("currentScreen") || null,
          previousScreen: sessionStorage.getItem("prevScreen"),
          carouselContents: searchResult?.results
        });
        sendSearchEventDataForBytePlus({ searchTerm: input, userData: this.state.userData || null });
      } catch (error) {
        if (isMounted !== true) {
          return;
        }
        const retry = () => {
          // Retry to refresh Search component
          this.componentDidMount();
          this.updateSearchQuery(this.state.searchTerm);
        };

        const back = () => {
          stateActions.hideGlobalModal();
          history.goBack();
        };
        if (!getAppState().isOnline && !error.status && !error.response) {
          stateActions.showGlobalModal(
            getInternetConnectivityModalConfig.call(this, {
              retryImplementation: retry,
              backImplementation: back
            })
          );
        } else {
          // If we already have results don't show the request failure - Disconnection Popup
          if (!!this.state.titles.length) {
            return false;
          }
          const buttons = [
            {
              ...getGlobalButtonInfo("retry"),
              buttonHandler: retry
            },
            {
              ...getGlobalButtonInfo("back"),
              buttonHandler: back
            }
          ];
          stateActions.showGlobalModal({
            modalText: i18n.get("global.errors.genericError"),
            buttons
          });
        }
        setFocus(getGlobalButtonFocusPath("retry"));
        return false;
      }
      let titlesArray = Search.processGridTitles(searchResult.results);
      if (!isResultsFromKeyword) {
        lastSearchResults = titlesArray;
        lastSearchTermTyped = input;
      } else {
        setKeyboardFocusFromKeywords = true;
      }
      history.replace({
        state: {
          lastSearch: titlesArray,
          lastKeywords: searchResult.keywords,
          focusedItem: 0,
          scrollToRow: 0,
          lastSearchTerm: this.state.searchTerm,
          appLangInLastSearch: i18n.getLocale(),
          keyboardLangSwap: this.keyboard.getCurrentName && this.keyboard.getCurrentName(),
          ...getSelectedKeywordIndex.call(this)
        }
      });
      this.setState({
        titles: titlesArray,
        searchTermExists: true,
        searching: false,
        ...(!isResultsFromKeyword && { keywords: searchResult.keywords }),
        ...(hasDidYouMean && { didYouMean: searchResult.didUMean })
      });
      isDidYouMean = false;
      !searchResult.results.length &&
        trackEvent("search_noresults_impression", null, SEARCH_NO_RESULTS, this.state.searchTerm);
    }
  }

  /**
   * Returns to previous page
   */
  onBack() {
    const { history } = this.props;
    this.setState({
      searchTerm: "",
      titles: [],
      searchTermExists: false,
      searchTermLength: false,
      searching: false,
      secondaryMenuSelectedIndex: -1
    });
    history.replace({
      state: {
        lastSearch: null,
        lastKeywords: null,
        lastSearchTerm: null,
        scrollToRow: null,
        offsetTopValue: null,
        keyboardLangSwap: null,
        appLangInLastSearch: null,
        ...(this.state.secondaryMenuSelectedIndex !== -1 && { secondaryMenuSelectedIndex: -1 })
      }
    });
    SearchKeyboard = null;
    lastFocusedKey = null;
    allLanguages = null;
    requestToken = null;
    isResultsFromKeyword = false;
    isDidYouMean = false;
    hasDidYouMean = false;
    isKeyboardInactive = true;
    isGridFocused = false;
    lastSearchResults = null;
    lastSearchTermTyped = "";
    setKeyboardFocusFromKeywords = false;
    lastKeywordFocused = null;
    return false;
  }

  /**
   * Updates history on each grid item change
   * @param {Object} focusedItem Grid item selected
   */
  onChange({ focusedItem }) {
    const { location, history } = this.props;
    if (focusedItem !== location.state.focusedItem) {
      history.replace({
        state: {
          ...history.location.state,
          focusedItem,
          scrollToRow: Math.floor(focusedItem / resolution.grid.search.columnCount),
          ...getSelectedKeywordIndex.call(this)
        }
      });
    }
  }

  /**
   * Calls to method which will send the request to search the keyword or didUmean selected
   * @param {Number} index Index of the selected keyword
   */
  onSelectKeyword(index) {
    const term = this.state.didYouMean[index] || this.state.keywords[index];
    if (!this.state.didYouMean[index]) {
      isResultsFromKeyword = true;
      lastKeywordFocused = `${SECONDARY_ITEM_PREFIX}${index}`;
      trackEvent(ANALYTICS_CATEGORY, "results|select_keyword", `${this.state.searchTerm}|${term}|${index + 1}`);
      this.setState({ secondaryMenuSelectedIndex: index });
    }
    if (this.state.didYouMean[index]) {
      const focusTarget = this.keyboard.getDefaultFocus ? this.keyboard.getDefaultFocus() : SearchKeyboard.defaultFocus;
      isDidYouMean = true;
      isKeyboardInactive = false;
      isResultsFromKeyword = false;
      this.props.setFocus(focusTarget);
      trackEvent(ANALYTICS_CATEGORY, "didumean|select_item", `${this.state.searchTerm}|${term}`);
    }
    this.updateSearchQuery(term);
  }

  /**
   * Go to detail page / Direct play on enter press
   */
  onEnterPress() {
    const {
      history,
      applicationState: {
        remoteConfig: { news_direct_playback, magazine_direct_playback }
      }
    } = this.props;
    const focusedItem = history.location.state.focusedItem;
    const title = this.state.titles[focusedItem || 0];
    const { id, programType, type } = title;
    const scrollToRow = Math.floor(focusedItem / resolution.grid.search.columnCount); // FIXME this calc is repeated in another line
    const selectedItemPosition = focusedItem + 1;
    const itemSelectionAction = isResultsFromKeyword
      ? "results|select_item_keyword_results"
      : `results|select_item|${type}`;
    // byte+
    const selectedItemOrder = this.state.titles.indexOf(title);
    const isNewsContent = !!(title?.contentType?.toLowerCase() === NEWS && news_direct_playback);
    const isMagazineContent = !!(title?.contentType?.toLowerCase() === MAGAZINE && magazine_direct_playback);
    sessionStorage.removeItem("refCarouselName");
    sessionStorage.removeItem("refCarId");
    sessionStorage.removeItem("refCarouselOrderId");
    var cp = sessionStorage?.getItem("currentScreen");
    var pp = sessionStorage?.getItem("prevScreen");
    setTimeout(() => {
      sendCarouselClickEventDataForBytePlus({
        mediaData: title,
        userData: this.state.userData || null,
        titleOrderId: selectedItemOrder,
        currentScreen: cp,
        previousScreen: pp
      });
    }, 1000);
    trackEvent(ANALYTICS_CATEGORY, itemSelectionAction, `${this.state.searchTerm}|${id}|${selectedItemPosition}`);
    this.props.history.replace({
      state: {
        ...history.location.state,
        scrollToRow,
        lastSearch: this.state.titles,
        lastKeywords: this.state.keywords,
        lastSearchTerm: this.state.searchTerm
      }
    });
    this.props.stateActions.setPosterLandscapeImage((title && title.images && title.images.posterLandscape) || "");
    if (isNewsContent || isMagazineContent) {
      const { seriesId, progress, onlineContent } = title;
      const contentType = isAVOD(title) ? "AVOD" : isSVOD(title) ? "SVOD" : isTVOD(title) ? "TVOD" : "";
      this.videoConfig = {
        id,
        progress,
        seriesId,
        titleId4K: title["4kProgramId"],
        contentType,
        onlineContent
      };
      playHandler.call(this, title, {
        from: {
          name: this.props.location.pathname || this.props.from,
          currentFocus: this.props.currentFocus || this.props.applicationState.currentFocus,
          index: -1
        }
      });
    } else {
      const isADMN = isADMNContent(title.contentOwnership) || false;
      goToDetailPageByProgramType.call(this, {
        id,
        programType,
        sectionName: getSectionName(isADMN, getPath(this.props)),
        from: {
          name: this.props.location.pathname || this.props.from,
          currentFocus: this.props.currentFocus || this.props.applicationState.currentFocus,
          index: -1
        }
      });
    }
  }

  /**
   * Add a new property for each title
   * @param {Array} titles List of titles
   */
  static processGridTitles(titles) {
    return titles.map((title, index) => {
      title.itemIndex = index;
      title["imageUrl"] = title.images.poster; // FIXME Exposing inconsistency in the data model, should be in SDK or MW
      return title;
    });
  }

  /**
   * Returns keyboard name depending on language
   * @param {String} lang Language
   */
  static getKeyboardForLanguage(lang) {
    switch (lang) {
      case "ar":
        return ArabicKeyboardSwap;
      default:
        return SimpleKeyboard;
    }
  }

  /**
   * Sets the focus on the keyboard
   * @param {Object} keyConf
   */
  focusKeyboard(keyConf) {
    const focusTarget = this.keyboard.getDefaultFocus ? this.keyboard.getDefaultFocus() : SearchKeyboard.defaultFocus;
    this.keyboard && this.props.setFocus(lastFocusedKey || (keyConf ? keyConf.defaultFocusPath : focusTarget));
  }

  /**
   * Swaps between arabic and english keyboard
   */
  onSwapKeyboard() {
    const { history } = this.props;
    const currentKeyboardName = this.keyboard.getCurrentName && this.keyboard.getCurrentName();
    if (history.location.state && history.location.state.keyboardLangSwap) {
      history.replace({
        state: Object.assign(isMounted ? {} : history.location.state, {
          keyboardLangSwap: currentKeyboardName
        })
      });
      if (isMounted) {
        this.setState({
          searchTerm: "",
          titles: [],
          didYouMean: [],
          searchTermExists: false,
          searching: false
        });
        lastFocusedKey = null;
        this.focusKeyboard();
      } else {
        isMounted = true;
      }
    } else {
      i18n.getLocale() === "ar" &&
        currentKeyboardName === keyboardTypes.WesternKeyboard.name &&
        trackEvent(PAGE, "change keyboard to En", "change keyboard to En");
      lastFocusedKey = null;
      this.focusKeyboard();
    }
    minCharacters = Search.getMinSearchCharactersForKeyboard(currentKeyboardName);
  }

  /**
   * Returns keyboard reference
   * @param {Object} keyboard
   */
  onRefKeyboard(keyboard) {
    this.keyboard = keyboard;
  }

  /**
   * Call to the method which updates the state and call to the method which will send the request
   * @param {Number} index Keyword index
   */
  onKeywordPress(index) {
    isResultsFromKeyword = false;
    this.updateSearchQuery(index);
  }

  moveFocusLeft() {
    this.moveFocus(directions.LEFT_TO_RIGHT);
  }

  moveFocusRight() {
    this.moveFocus(directions.RIGHT_TO_LEFT);
  }

  moveFocus(direction) {
    if (isKeyboardInactive) {
      if (i18n.getDirection() !== direction) {
        return;
      }
      this.props.setFocus(lastKeywordFocused);
    } else {
      i18n.getDirection() === direction && this.focusKeyboard();
    }
  }

  /**
   * Returns the minimum characters to send the search
   * @param {String} keyboardName
   */
  static getMinSearchCharactersForKeyboard(keyboardName) {
    const searchMinCharactersConfig = getAppState().globalConfig?.search.queryMinCharacters;
    return searchMinCharactersConfig[keyboardTypes[keyboardName].languageCode] || searchMinCharactersConfig.default;
  }
  closeModal() {
    this.props.stateActions.hideGlobalModal();
    if (getAppState().signupPromptActive) {
      getAppState().signupPromptActive = false;
    }
  }

  render() {
    const { location } = this.props;
    return (
      <SearchPageStyled>
        <ContainerStyled>
          <BlockStyled
            isKeyboardInactive={isKeyboardInactive}
            didYouMeanVisible={this.state.didYouMean && this.state.didYouMean.length > 0}
            position={
              i18n.getLocale() === "ar" ? resolution.search.positionNavigationAR : resolution.search.positionNavigation
            }
          >
            <HeadingStyled rank={1} text={i18n.get("pages.search.title")} />
            {SearchKeyboard && (
              <ContainerKeyboardStyled inactive={isKeyboardInactive}>
                <SearchKeyboard
                  text={this.state.searchTerm}
                  onChange={this.onKeywordPress}
                  onAction={this.onKeywordPress}
                  exitNavigationTrap={!!this.state.titles.length}
                  direction={i18n.getDirection()}
                  onSwap={this.onSwapKeyboard}
                  onFocus={({ focusPath }) => (lastFocusedKey = focusPath)}
                  ref={this.onRefKeyboard}
                  dataSnDown={
                    (this.state.keywords && this.state.keywords.length) ||
                    (this.state.didYouMean && this.state.didYouMean.length)
                      ? `@${SECONDARY_ITEM_PREFIX}0`
                      : ""
                  }
                  dataSnUp={""}
                />
              </ContainerKeyboardStyled>
            )}
            {this.state.keywords && !!this.state.keywords.length && !!this.state.titles.length && (
              <SecondaryMenu
                items={this.state.keywords}
                onClick={this.onSelectKeyword}
                onMouseUp={this.onSelectKeyword}
                secondaryMenuSelectedIndex={this.state.secondaryMenuSelectedIndex}
                size={"medium"}
                dataSnDown=""
              />
            )}
            {this.state.didYouMean && !!this.state.didYouMean.length && (
              <>
                <Text text={i18n.get("pages.search.didYouMean")} type={"default"} size={"small"} />
                <SecondaryMenu
                  items={this.state.didYouMean}
                  onClick={this.onSelectKeyword}
                  onMouseUp={this.onSelectKeyword}
                  secondaryMenuSelectedIndex={this.state.secondaryMenuSelectedIndex}
                  size={"medium"}
                  weight={"bold"}
                  dataSnDown=""
                />
              </>
            )}
          </BlockStyled>
          <BlockStyled>
            <Input
              id="search-input"
              type="text"
              value={this.state.searchTerm}
              placeholder={
                isResultsFromKeyword ? i18n.get("pages.search.titlesRelatedTo") : i18n.get("pages.search.searchFor")
              }
              active={true}
              readOnly
            />

            {this.state.searching && !this.state.searchTermExists && <LoadingStyled />}
            <GridStyled
              titles={getTitlesFormattedForCarousels.call(this, "", this.state.titles)}
              noResultText={
                this.state.searchTermExists
                  ? i18n.get("pages.search.noResults")
                  : this.state.searchTermLength
                  ? i18n.get("pages.search.minLength", minCharacters)
                  : ""
              }
              onEnterPress={this.onEnterPress}
              columnCount={resolution.grid.search.columnCount}
              columnWidth={resolution.grid.search.columnWidth}
              itemHeight={resolution.grid.search.itemHeight}
              rowHeight={resolution.grid.search.rowHeight}
              offsetFixed={true}
              gridDataContent={this.state.searchTerm}
              navigateLeft={this.moveFocusLeft}
              navigateRight={this.moveFocusRight}
              direction={i18n.getDirection()}
              onChange={this.onChange}
              type={"white"}
              scrollToRow={location.state ? location.state.scrollToRow : 0}
              focusedItem={location.state ? location.state.focusedItem : 0}
              isFocused={this.props.applicationState.currentFocus === GridStyled.defaultFocusPath}
              expireTime={tvodSearchTimeExpire}
            >
              {this.state.searching && this.state.searchTermExists && <Loading overlay />}
            </GridStyled>
          </BlockStyled>
        </ContainerStyled>
      </SearchPageStyled>
    );
  }
}

export default withAppState(withSubtheme(Search));
